/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React, { useLayoutEffect, useRef } from 'react';
import { HotjarMaskProps } from './HotJarMaskProps';

export const MASKED = 'data-hj-suppress';
export const ALLOWED = 'data-hj-allow';

/**
 * Reference doc:
 * https://help.hotjar.com/hc/en-us/articles/115012439167-How-to-Suppress-Text-Images-and-User-Input-from-Collected-Data
 * Wrapper component to do masking/unmasking in HotJar library.
 * Example:
 *      - If you want to mask profile picture, Wrap the Avatar component with
 *           <HotjarMask isMasked>
 *               <Avatar .../>
 *           </HotjarMask>
 *      - As per Hotjar cloud configs all texts are masked, So if you want to unmask a text or any element wrap it as
 *           <HotjarMask isAllowed>
 *               <MyText .../>
 *           </HotjarMask>
 *
 * @param {HotjarMaskProps} { children, isMasked, isAllowed }
 * @return {React.ReactNode} HotjarMask component
 */
const HotjarMask = ({ children, isMasked, isAllowed }: HotjarMaskProps) => {
  const masked = isMasked ? MASKED : isAllowed ? ALLOWED : '';
  const dataAttr = `data-${masked}`;
  const props = { className: masked, [dataAttr]: ''}
  return <span {...props}>{children}</span>;
};

export default HotjarMask;
